import { makeStyles } from "@mui/styles";
import { Commons, colors } from "styleguide";

const styles = makeStyles({
  contFooter: {
    ...Commons.flexRow,
    alignItems: "flex-start",
    backgroundColor: colors.black,
    padding: "12px 60px",
    borderTop: `2px solid ${colors.orange}`,
    marginTop: 30,
    [Commons.smallQuery]: {
      ...Commons.flexColumn,
      padding: "12px",
    },
  },
  hide: {
    display: "none",
  },
  column: {
    ...Commons.flexColumn,
    alignItems: "start",
    flex: 1,
    margin: 30,
    [Commons.smallQuery]: {
      width: "calc(100% - 60px)",
    },
  },
  logo: {
    marginTop: 48,
    cursor: "pointer",
    width: "100%",
    [Commons.smallQuery]: {
      marginTop: 0,
    },
  },
  imgLogo: {
    height: "auto",
    width: "100%",
    objectFit: "contain",
    maxWidth: 300,
  },
  titleColumn: {
    margin: 0,
    fontSize: 18,
    fontWeight: "bold",
    marginBottom: 18,
    color: colors.white,
  },
  link: {
    color: colors.white,
    textDecoration: "none",
    cursor: "pointer",
    margin: "6px 0px",
  },
  languageSwitcher: {
    ...Commons.defaultButton,
    border: `3px solid ${colors.themeColor}`,
    borderRadius: 30,
    color: colors.white,
    cursor: "pointer",
    margin: "6px 0px",
    padding: "3px 12px",
    transition: "all 0.3s",
    "&:hover": {
      backgroundColor: colors.white,
      color: colors.black,
    },
  },
  container: {
    ...Commons.flexCenter,
    width: "100%",
    backgroundColor: colors.orange,
    color: colors.white,
    textAlign: "center",
    padding: "18px 0",
    fontWeight: 500,
    fontSize: 18,
    position: "relative",
    zIndex: 101,
  },
});

export default styles;
